import { Injectable, computed, inject, signal } from '@angular/core';
import { ServiceConditionApi } from '../api/service-conditions.api';

@Injectable({
  providedIn: 'root',
})
export class ServiceConditionStore {
  private readonly api = inject(ServiceConditionApi);

  readonly notifications = signal<any[]>([]);
  readonly loading = signal(false);
  readonly error = signal<any>(null);

  readonly isBannerVisible = computed(() => this.notifications().length > 0);

  loadBannerNotifications(): void {
    this.loading.set(true);
    this.error.set(null);

    this.api.getBannerNotifications().subscribe({
      next: (response) => {
        this.notifications.set(response ?? []);
        this.loading.set(false);
      },
      error: (err) => {
        this.notifications.set([]);
        this.error.set(err);
        this.loading.set(false);
      },
    });
  }

  dismissBannerNotification(payload: any) {
    return this.api.dismissBannerNotification(payload);
  }

  acceptServiceCondition(payload: any) {
    return this.api.acceptServiceCondition(payload);
  }
}
